export default "__VITE_ASSET__Cgkkr$WL__"